import React from 'react';

import StyledComponent from '~/components/Styled/Styled';
import getOr from '~/util/getOr';
import css from './GraphQLEventDescriptionCard.scss';

interface Props {
  data: {
    node: {};
  };
  event: {
    tournamentName: string;
    live: string;
    status: string;
  };
  Details: React.ElementType;
}

class GraphQLEventDescriptionCard extends React.Component<Props, State> {
  static displayName = 'GraphQLEventDescriptionCard';

  render() {
    const { Details, data } = this.props;
    const name = getOr(this.props, 'event.tournamentName', '');
    const live = getOr(this.props, 'event.live', false);
    const eventStatus = getOr(this.props, 'event.status', '');

    return (
      <div className={css.matchupDescriptionContainer}>
        <div>
          <div className={css.eventName}>{name}</div>
          {live && <div className={css.statusLive}>LIVE</div>}
        </div>
        <div className={css.descriptionElementsContainer}>
          <Details data={data} eventStatus={eventStatus} />
        </div>
      </div>
    );
  }
}

export default StyledComponent(GraphQLEventDescriptionCard, [css]);
